import React, { Component } from "react";
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Get Tours
import { getTours, getTourDetails } from "./../../store/tour/actions";
import { createPack } from "./../../store/pack/actions";

class NewPack extends Component {
  constructor(props) {
    super(props);
    this.state = { tour: "", isLoading: false };
  }

  componentDidMount() {
    this.props.getTours();
    //console.log(this.props.location.state.tour_id);
    if (this.props.location.state.tour_id) {
      this.setState({
        tour_id: this.props.location.state.tour_id,
      });
    }
  }

  change = event => {
    //console.log(event.target.value);
    this.setState({ tour: event.target.value });
  };

  render() {
    var tourslist = this.props.tours;
    //console.log(tourslist);
    //meta title
    document.title = "New Pack | Loadout Admin Dashboard";
    return (
      <React.Fragment>
        {this.state.isLoading ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="page-content">
            <Container fluid>
              {/* Render Breadcrumbs */}
              <Breadcrumbs title="Pack" breadcrumbItem="New Pack" />
              <Row>
                <Col lg="12" sm="12">
                  <Card>
                    <CardBody>
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          tour:
                            (this.state && this.state.tour) ||
                            this.state.tour_id,
                          name: (this.state && this.state.name) || "",
                          category: (this.state && this.state.category) || "",
                        }}
                        validationSchema={Yup.object().shape({
                          tour: Yup.string().required("Please Select Tour"),
                          name: Yup.string().required("Please Enter Pack Name"),
                          category: Yup.string().required(
                            "Please Enter Category"
                          ),
                        })}
                        onSubmit={values => {
                          this.setState({ isLoading: true });
                          this.props.createPack(values, this.props.history);
                        }}
                      >
                        {({ errors, status, touched }) => (
                          <Form>
                            <div>
                              <p className="card-title-desc">
                                Fill all information below
                              </p>
                              <div className="mb-3">
                                <Label>Tour</Label>
                                <select
                                  className={
                                    "form-control" +
                                    (errors.tour && touched.tour
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="tour"
                                  onChange={this.change}
                                  value={
                                    this.state.tour
                                      ? this.state.tour
                                      : this.state.tour_id
                                  }
                                >
                                  <option value="">Select Tour</option>
                                  {tourslist.map((x, y) =>
                                    x.det.st ? (
                                      <option key={x.id} value={x.id}>
                                        {x.det.nm}
                                        {" - "}
                                        {x.det.snm}
                                      </option>
                                    ) : null
                                  )}
                                  ;
                                </select>
                                <ErrorMessage
                                  name="tour"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="mb-3">
                                <Label>Name</Label>
                                <Field
                                  name="name"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="mb-3">
                                <Label>Category</Label>
                                <Field
                                  name="category"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.category && touched.category
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="text-start">
                                {this.state.tour_id ? (
                                  <Link
                                    to={"/view-tour/" + this.state.tour_id}
                                    className="btn btn-dark"
                                  >
                                    Back
                                  </Link>
                                ) : (
                                  <Link
                                    to="/pack-list"
                                    className="btn btn-dark"
                                  >
                                    Back
                                  </Link>
                                )}
                              </div>
                              <div className="text-end">
                                <button
                                  className="btn btn-info mt-3"
                                  type="submit"
                                >
                                  Create Pack
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </React.Fragment>
    );
  }
}

NewPack.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  success: PropTypes.any,
  history: PropTypes.object,
  tours: PropTypes.object,
  createPack: PropTypes.func,
};

const mapStateToProps = state => {
  //console.log(state);
  const { error, success, tours } = state.Tour;
  return { error, success, tours };
};

export default withRouter(
  connect(mapStateToProps, { getTours, createPack, getTourDetails })(NewPack)
);
